module.exports = __webpack_public_path__ + "static/ndc-884ebcf5e037a62eab0e291050a63955.jpg";